<script lang="ts">
	import type { HTMLAnchorAttributes, MouseEventHandler } from "svelte/elements";
	import basket from "@core/assets/icons/basket.svg?raw";
	import { getBuyPath } from "@core/schema/paths/getBuyPath.js";
	import { getIdFromPath } from "@core/schema/utils/getIdFromPath.js";
	import { getGlobalTemplateProps } from "../contexts/getGlobalTemplateProps.js";
	import { cartSummaryHeight } from "../state/cartSummaryHeight.svelte.js";
	import Icon from "./common/Icon.svelte";
	import Link from "./common/Link.svelte";
	import { ButtonVariant } from "./common/getButtonClass.js";

	const {
		variant = ButtonVariant.Primary,
		baseWidth,
		children,
		noIcon = false,
		icon = basket,
		class: className,
		onclick: defaultOnclick,
		...props
	}: { baseWidth?: boolean; variant?: ButtonVariant; noIcon?: boolean; icon?: string } & Omit<
		HTMLAnchorAttributes,
		"download" | "href"
	> = $props();

	const { tenant } = getGlobalTemplateProps();

	const onclick: MouseEventHandler<HTMLAnchorElement> = (e): void => {
		defaultOnclick?.(e);
		const target = document.getElementById(getIdFromPath(getBuyPath(tenant.locale)));
		if (target === null) {
			return;
		}
		e.preventDefault();
		const { top } = target.getBoundingClientRect();
		window.scrollTo({
			top: top + window.scrollY + target.clientHeight - window.innerHeight + cartSummaryHeight.value,
			behavior: "smooth",
		});
	};
</script>

<Link
	class={[
		"gap-2",
		{
			"lg:w-104": !baseWidth,
		},
		className,
	]}
	{variant}
	{...props}
	{onclick}
	href={getBuyPath(tenant.locale)}
>
	<span>
		{#if children !== undefined}
			{@render children()}
		{:else}
			Chci přenosné ohniště
		{/if}
	</span>
	{#if !noIcon}
		<Icon {icon} class="size-[1.25em] -translate-y-[0.125em]" />
	{/if}
</Link>
